import React, { useEffect, useState } from "react";

const AuthorizationError = ({ module }) => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFadeIn(true);
    }, 100); // Slight delay to trigger the transition
  }, []);

  return (
    <div
      style={{
        ...styles.container,
        opacity: fadeIn ? 1 : 0, // Apply opacity based on state
        transition: "opacity 2s ease-in-out", // Smooth transition over 2 seconds
      }}
    >
      <div style={styles.content}>
        <h1 style={styles.title}>Access Denied</h1>
        <p style={styles.message}>
          Sorry, you don't have permission to access this {module} module.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f2f2f2",
    padding: "0 20px",
    opacity: 0, // Initial opacity for the fade-in effect
  },
  content: {
    textAlign: "center",
    background: "#fff",
    padding: "40px 30px",
    borderRadius: "10px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
  },
  title: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "30px",
  },
  button: {
    display: "inline-block",
    padding: "10px 20px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#ff7f50",
    textDecoration: "none",
    borderRadius: "5px",
    transition: "background-color 0.3s",
  },
};

styles.button[':hover'] = {
  backgroundColor: "#ff5733",
};

export default AuthorizationError;
